module.exports = __webpack_public_path__ + "fonts/GenSenRounded-R.f85c17a7.woff2";